import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter);

// 嵌套路由
const routes = [
    // 主路由
    { path: '/', name: 'root', component: () => import('../views/frame/Main') },
    {
        path: '/login',
        name: 'login',
        meta: { title: '登陆页' },
        component: () => import('../views/login/Login')
    },
    // home
    {
        path: '/h/:id',
        name: 'home',
        component: () => import('../views/frame/Main'),
        children: [
            { path: 'mytask', name: 'mytask', meta: { title: '我的待办' }, component: () => import('../views/userhome/MyTask') },
            { path: 'mystart', name: 'mystart', meta: { title: '发起流程' }, component: () => import('../views/userhome/MyStart') },
            { path: 'myjoin', name: 'myjoin', meta: { title: '我参与的' }, component: () => import('../views/userhome/MyJoin.vue') },
        ]
    },
    // 销售管理(salemg)
    {
        path: '/salemg/:id',
        name: 'sale',
        component: () => import('../views/frame/Main'),
        children: [
            { path: 'cstm', name: 's_customer', meta: { title: '客户信息' }, component: () => import('../views/salemg/Customer.vue') },
            { path: 'ctrt', name: 's_contract', meta: { title: '销售合同' }, component: () => import('../views/salemg/Contract.vue') },
            { path: 'spo', name: 's_po', meta: { title: '销售订单' }, component: () => import('../views/salemg/So.vue') },
            { path: 'sgoods', name: 's_send_goods', meta: { title: '销售发货' }, component: () => import('../views/salemg/SendGoods.vue') },
            { path: 'retgoods', name: 's_return_goods', meta: { title: '销售退货' }, component: () => import('../views/salemg/ReturnGoods.vue') },
            { path: 'creceipt', name: 's_customer_receipt', meta: { title: '客户收货单' }, component: () => import('../views/salemg/CustomerReceipt') },
        ]
    },
    // 采购管理(purchasemg)
    {
        path: '/prchsmg/:id',
        name: 'purchase',
        component: () => import('../views/frame/Main'),
        children: [
            { path: 'papply', name: 'p_apply', meta: { title: '采购申请' }, component: () => import('../views/purchasemg/Apply.vue') },
            { path: 'ppredict', name: 'p_predict', meta: { title: '采购预测' }, component: () => import('../views/purchasemg/Predict') },
            { path: 'ppo', name: 'p_po', meta: { title: '采购订单' }, component: () => import('../views/purchasemg/Po.vue') },
            { path: 'ctrt', name: 'p_contract', meta: { title: '采购合同' }, component: () => import('../views/purchasemg/Contract.vue') },
            { path: 'supplier', name: 'p_supplier', meta: { title: '供应商管理' }, component: () => import('../views/purchasemg/Supplier.vue') },
            { path: 'asn', name: 'p_asn', meta: { title: 'ASN单据' }, component: () => import('../views/purchasemg/Asn.vue') },
            { path: 'recgoods', name: 'p_recieve_goods', meta: { title: '采购收货' }, component: () => import('../views/purchasemg/ReceiveGoods.vue') },
            { path: 'scanrecgoods', name: 'p_scan_recieve_goods', meta: { title: '扫描收货' }, component: () => import('../views/purchasemg/ScanReceiveGoods.vue') },
            { path: 'ntcheck', name: 'p_notice_check', meta: { title: '对账通知' }, component: () => import('../views/purchasemg/NoticeCheck.vue') },
            { path: 'ntpay', name: 'p_notice_pay', meta: { title: '支付通知' }, component: () => import('../views/purchasemg/NoticePay.vue') },
            { path: 'retgoods', name: 'p_return_goods', meta: { title: '采购退货' }, component: () => import('../views/purchasemg/ReturnGoods.vue') },
        ]
    },

    // 库存管理(inventory)
    {
        path: '/ivt/:id',
        name: 'inventory',
        component: () => import('../views/frame/Main'),
        children: [
            { path: 'mng', name: 'ivt_mng', meta: { title: '库位管理' }, component: () => import('../views/inventory/IvtManage') },
            { path: 'move', name: 'ivt_move', meta: { title: '库存移动' }, component: () => import('../views/inventory/IvtMove') },
            { path: 'query', name: 'ivt_query', meta: { title: '库存查询' }, component: () => import('../views/inventory/IvtQuery') },
            { path: 'nmb', name: 'ivt_nmb', meta: { title: '批次/序列号' }, component: () => import('../views/inventory/IvtNumber') },
        ]
    },
    // 票据管理(billmg) 销售 采购
    {
        path: '/billmg/:id',
        name: 'bill',
        component: () => import('../views/frame/Main'),
        children: [
            { path: 'sale', name: 's_bill', meta: { title: '销售票据' }, component: () => import('../views/billmg/SaleBill') },
            { path: 'prchs', name: 'p_bill', meta: { title: '采购票据' }, component: () => import('../views/billmg/PurchaseBill') },
        ]
    },

    // 组织管理(org)
    {
        path: '/org/:id',
        name: 'org',
        component: () => import('../views/frame/Main'),
        children: [
            { path: "setting", name: "orgset", meta: { title: "组织管理" }, component: () => import("../views/org/Org") },
        ]
    },

    // 物料主数据维护(material)
    {
        path: '/material/:id',
        name: 'material',
        component: () => import('../views/frame/Main'),
        children: [
            { path: "main", name: "main", meta: { title: "物料基础主数据" }, component: () => import("../views/material/MainMaterial") },
            { path: "uom", name: "uom", meta: { title: "计量单位管理" }, component: () => import("../views/material/Uom") },
        ]
    },

    // 供应商协同(supplier)
    {
        path: "/supplier/:id",
        name: "supplier",
        component: () => import("../views/frame/Main"),
        children: [
            { path: "inquiry", name: "sup_inquiry", meta: { title: "询价" }, component: () => import("../views/supplier/Inquiry.vue") },
            { path: "prepo", name: "sup_predict_po", meta: { title: "采购预测计划" }, component: () => import("../views/supplier/PredictPo.vue") },
            { path: "po", name: "sup_po", meta: { title: "采购订单" }, component: () => import("../views/supplier/Po") },
            { path: "gvgoods", name: "sup_give_goods", meta: { title: "交货管理" }, component: () => import("../views/supplier/GiveGoods.vue") },
            { path: "recgoods", name: "sup_recieve_goods", meta: { title: "收货管理" }, component: () => import("../views/supplier/ReceiveGoods.vue") },
            { path: "ntcheck", name: "sup_notice_check", meta: { title: "对账结算" }, component: () => import("../views/supplier/NoticeCheck.vue") },
            { path: "billmg", name: "sup_bill_manage", meta: { title: "票据管理" }, component: () => import("../views/supplier/BillManage") },
        ]
    },

    // 供应商信息管理(suppliermg)
    {
        path: "/suppliermg/:id",
        name: "suppliermg",
        component: () => import("../views/frame/Main"),
        children: [
            { path: "info", name: "sup_info_manage", meta: { title: "供应商信息维护" }, component: () => import("../views/suppliermg/SupInfo.vue") },
        ]
    },

    // 用户管理(usermg)
    {
        path: '/user/:id',
        name: 'user',
        component: () => import('../views/frame/Main'),
        children: [
            { path: 'ad', name: "ad'", meta: { title: 'AD设置' }, component: () => import('../views/usermg/Ad') },
            { path: 'role', name: "role", meta: { title: '角色管理' }, component: () => import('../views/usermg/Role') },
            { path: 'list', name: "userlist", meta: { title: '用户列表' }, component: () => import('../views/usermg/User') },
        ]
    },

    // 基础设置(base)
    {
        path: '/base/:id',
        name: 'base',
        component: () => import('../views/frame/Main'),
        children: [
            { path: 'info', name: "pub_notice", meta: { title: '公告信息设置' }, component: () => import('../views/base/PublicInfo') },
            { path: 'dict', name: "maintain_dict", meta: { title: '分类字典维护' }, component: () => import('../views/base/DictMaintain') },
            { path: 'interface', name: "interface_mng", meta: { title: '接口管理' }, component: () => import('../views/base/InterfaceManage') },
        ]
    },

    // 计算中心(compute)
    {
        path: '/cptcenter/:id',
        name: 'compute',
        component: () => import('../views/frame/Main'),
        children: [
            { path: 'pdemand', name: "p_demand", meta: { title: '采购需求计算' }, component: () => import('../views/compute/PurchaseCompute') },
        ]
    },

    //公司间交易
    {
        path: "/intrade/:id",
        name: "intrade",
        component: () => import("../views/frame/Main.vue"),
        children: [
            { path: "internalpo", name: "s_internal_po", meta: { title: "收到的PO" }, component: () => import("../views/intrade/InternalPo.vue") },
            { path: "internalsalesend", name: "s_internal_salesend", meta: { title: "对方已发" }, component: () => import("../views/intrade/SaleSend.vue") },
            { path: "internalbuyergr", name: "s_internal_buyergr", meta: { title: "对方已收" }, component: () => import("../views/intrade/BuyerGr.vue") },
            { path: "internalreceivedbill", name: "s_internal_received_bill", meta: { title: "对账单" }, component: () => import("../views/intrade/ReceivedBill.vue") },
        ]
    },

];


// 3. 创建 router 实例
const router = new VueRouter({
    mode: "history",
    routes
});

// 解决 Vue 重复点击相同路由报错问题
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
};

export default router

// 4. 将router挂载到根节点上（在main.js上挂载）